// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slidePanel-enter-active[data-v-09645e38],\n.slidePanel-leave-active[data-v-09645e38] {\n  max-height: 1000px;\n  -webkit-transition: max-height 500ms ease;\n  transition: max-height 500ms ease;\n}\n.slidePanel-enter[data-v-09645e38],\n.slidePanel-leave-to[data-v-09645e38] {\n  max-height: 0;\n}", ""]);
// Exports
module.exports = exports;
